<template>
  <div class="md-layout">
    <!-- 顶部 数据显示+查询表单 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content class="md-layout">
          <!-- 顶部-数据展示 -->
          <div class="md-layout-item md-layout md-size-50 md-xsmall-size-100" :style="{'padding':0}">
            <!-- 云服务器 -->
            <div class="md-layout-item md-size-33 md-xsmall-size-33">
              <p>{{$I18n("cloud_server")}}</p>
              <p :style="{'font-weight':600}">{{serverInfo.Form.ip_num ?serverInfo.Form.ip_num :0}}</p>
            </div>
            <!-- 云服务 -->
            <div class="md-layout-item md-size-33 md-xsmall-size-33">
              <p>{{$I18n("cloud_service")}}</p>
              <p :style="{'font-weight':600}">{{serverInfo.Form.srv_num ?serverInfo.Form.srv_num :0}}</p>
            </div>
            <!-- 在线 -->
            <div class="md-layout-item md-size-33 md-xsmall-size-33 canclick" :class="{selected: searchData.state == 1}" @click="changeState(1)">
              <p>{{$I18n("inline")}}</p>
              <p :style="{'font-weight':600}">{{serverInfo.Form.online_num ?serverInfo.Form.online_num :0}}</p>
            </div>
          </div>
          <!-- 顶部-数据展示(可点击进行数据筛选) -->
          <div class="md-layout-item md-layout md-size-50 md-xsmall-size-100" :style="{'padding':0}">
            <!-- 离线 -->
            <div class="md-layout-item md-size-25 md-xsmall-size-25 canclick" :class="{selected: searchData.state == 2}" @click="changeState(2)">
              <p>{{$I18n("offline")}}</p>
              <p :style="{'font-weight':600}">{{serverInfo.Form.offline_num ?serverInfo.Form.offline_num :0}}</p>
            </div>
            <!-- 未授权 -->
            <div class="md-layout-item md-size-25 md-xsmall-size-25 canclick" :class="{selected: searchData.state == 3}" @click="changeState(3)">
              <p>{{$I18n("unauth")}}</p>
              <p :style="{'font-weight':600}">{{serverInfo.Form.noauth_num ?serverInfo.Form.noauth_num :0}}</p>
            </div>
            <!-- 下线 -->
            <div class="md-layout-item md-size-25 md-xsmall-size-25 canclick" :class="{selected: searchData.state == 4}" @click="changeState(4)">
              <p>{{$I18n("outline")}}</p>
              <p :style="{'font-weight':600}">{{serverInfo.Form.cancel_num ?serverInfo.Form.cancel_num :0}}</p>
            </div>
            <!-- 警告 -->
            <div class="md-layout-item md-size-25 md-xsmall-size-25 canclick" :class="{selected: searchData.state == 5}" @click="changeState(5)">
              <p>{{$I18n("warning")}}</p>
              <p :style="{'font-weight':600}">{{serverInfo.Form.warning_num ?serverInfo.Form.warning_num :0}}</p>
            </div>
          </div>
          <!-- 顶部-检索表单 -->
          <div class="md-layout card-form">
            <div class="md-layout-item md-layout md-size-70 md-xsmall-size-100" :style="{'padding':'0'}">
              <!-- 表单-选择栏-参数类型 -->
              <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <md-select v-model="searchForm.Form.searchType">
                    <md-option :value="'ip'">{{"IP"}}</md-option>
                    <md-option :value="'zone'">{{$I18n('belong_areas')}}</md-option>
                    <md-option :value="'region'">{{$I18n('belong_co')}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-输入栏-参数值 -->
              <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item" style="position: relative;">
                <md-field>
                  <label v-if="searchForm.Form.searchType === 'ip'">{{"IP"}}</label>
                  <label v-if="searchForm.Form.searchType === 'zone'">{{$I18n("belong_areas")}}</label>
                  <label v-if="searchForm.Form.searchType === 'region'">{{$I18n("belong_co")}}</label>
                  <template>
                    <md-input v-if="searchForm.Form.searchType === 'ip'" v-model="searchForm.Form.searchValue"/>
                    <md-select v-else-if="searchForm.Form.searchType === 'region'" v-model="searchForm.Form.searchValue">
                      <md-option value="ALL">{{$I18n("all")}}</md-option>
                      <md-option v-for="item in continentArray" :key="'main_'+item.code" :value="item.code">
                        {{$router.history.current.query.lang === "zh" ?item.cn_name :item.name}}
                      </md-option>
                    </md-select>
                    <template v-else>
                      <md-select v-model="searchForm.Form.searchValue">
                        <md-option value="ALL">{{$I18n("all")}}</md-option>
                        <md-option v-for="item in countryArray" :key="item.code" :value="item.code">{{
                          $router.history.current.query.lang === "zh" ?item.cn_name :item.name
                        }}</md-option>
                      </md-select>
                      <div @click="$refs.zone.open()" style="position:absolute; top: 0; bottom: 0;left: 0; right: 0;z-index: 1;cursor: pointer;"></div>
                    </template>
                  </template>
                </md-field>
                <!-- <md-button 
                  v-show="searchForm.Form.searchType === 'zone'" 
                  class="md-just-icon md-simple md-primary" 
                  @click=""
                  style="position: absolute;top: 0;right: 16px;"
                >
                  <md-icon>search</md-icon>
                </md-button> -->
              </div>
              <!-- 表单-选择栏-状态 -->
              <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <label>{{$I18n("status")}}</label>
                  <md-select v-model="searchForm.Form.state">
                    <md-option :value="0">{{$I18n('all')}}</md-option>
                    <md-option v-for="item in $Param.serverStatus" :key="item.sort" :value="item.id">{{$I18n(item.name)}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-选择栏-类型 -->
              <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <label>{{$I18n("type")}}</label>
                  <!-- <md-select multiple v-model="searchForm.Form.type"> -->
                  <md-select v-model="searchForm.Form.type">
                    <md-option :value="0">{{$I18n('all')}}</md-option>
                    <md-option v-for="item in server_simp_type" :key="item.id" :value="item.id">{{item.name}}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="md-layout-item md-size-30 md-xsmall-size-100">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
              <md-button class= "left-icon md-info" @click="form_openEmail">
                <md-icon>email</md-icon>
                {{$I18n("info_setting")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card> 
    </div>
    <!-- 主体-服务器数据卡片展示 -->
    <div class="md-layout-item md-size-100 main-table">
      <md-card>
        <md-card-content v-if="$router.history.current.query && $router.history.current.query.sp === '1'">
          <md-table v-model="tablePageData" md-model-id="net_addr">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="$I18n('ip')">
                <div>
                  <div>{{item.zone?`[${item.zone}]` :"[XX]"}}{{item.net_addr}}</div>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-content v-else>
          <md-table v-model="tablePageData" md-model-id="net_addr">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="$I18n('ip')">
                <div>
                  <div>{{item.net_addr}}</div>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('belong')">
                <div>
                  <div>{{item.zone_name}}/{{item.region_name}}</div>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="'CPU'">
                <div>
                  <div>{{item.cpu_rate}}%</div>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('memory_rate')">
                <div>
                  <div>{{item.memory.used}}/{{item.memory.total}}</div>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('harddisk')">
                <div>
                  <div v-for="(sub_disk, sub_index) in item.disk.filter((_, index) => {return index < 2})" :key="sub_index" class="info-sub">
                    <div class="info-title">{{sub_disk.name}} {{sub_disk.used}}/{{sub_disk.total}}</div>
                  </div>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('data')">
                <div>
                  <div class="num-box" v-if="item.dev_load">
                    <div class="num-info-box">
                      <span class="bold">{{$I18n("dev_online")}}:</span>
                      {{item.dev_load?item.dev_load :0}}
                    </div>
                  </div>
                  <div class="num-box" v-if="item.attr && (item.attr.lic_count || item.attr.lic_num)">
                    <div class="num-info-box">
                      <span class="bold">{{$I18n("id_num")}}: </span>
                      {{(item.attr && item.attr.lic_count) ?item.attr.lic_count :0}}
                      /
                      {{(item.attr && item.attr.lic_num) ?item.attr.lic_num :0}}
                    </div>
                  </div>
                  
                  <div class="num-box" v-if="item.attr && (item.attr.t_cur_load || item.attr.t_month_load)">
                    <div class="num-info-box">
                      <span class="bold">{{$I18n("trans")}}:</span>
                      {{item.month_load}}/{{$I18n("month")}}
                      ,
                      {{item.cur_load}}/{{$I18n("second")}}
                    </div>
                  </div>

                  <div class="num-box" v-if="item.ssl_days_left">
                    <div class="num-info-box">
                      <span class="bold">{{$I18n("ssl_days_left")}}:</span>
                      {{item.ssl_days_left?item.ssl_days_left :0}}
                    </div>
                  </div>
                </div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('server')">
                <div class="server">
                  <template v-for="(server,index) in item.service_item" >
                    <div
                      :key="server.app_id"
                      class="md-chip md-theme-default" 
                      @click="openServerModal(server, item)" 
                      :class="{
                        'md-info': server.state == 1,
                        'md-danger': server.state == 2,
                      }"
                    >
                      <div class="md-ripple">{{server.type_name}}{{server.master_name}} [{{server.ver}}]</div>
                    </div>
                    <div v-if="index%4 === 3" style="width: 100%;height: 1px;" :key="index+'_line'"></div>
                  </template>
                  
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
    <!-- 主体-翻页 -->
    <div class="md-layout-item md-size-100"> 
      <!-- <table-page-v :total="total" :pageSize="pageSize" v-model="currentPage"/> -->
      <table-page-v2 :showTotal="true" :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
    </div>
    <zone-select-modal ref="zone" @select="zone => (searchForm.Form.searchValue = zone)"/>
    <!-- 弹窗 Email -->
    <simple-modal ref="email_info" :title= "$I18n('info_setting')" :right="true" :large="true">
      <template slot="body">
        <div :style="{'text-align':'left'}" >
          <md-button class="md-round md-info md-just-icon" @click="modal_add_email">
            <md-icon>add</md-icon>
          </md-button>
          <div :style="{'clear':'both'}"></div>
          <md-table v-model="modalTableData" class="left-table">
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sys')">{{ item.sys == "all" ?$I18n("all") :item.sys }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.link_type == 1 ?$I18n("simple_email") :$I18n("simple_phone") }}</md-table-cell>
              <md-table-cell :md-label="$I18n('rele_param')">{{ item.link }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.state == 1 ? $I18n("open") : $I18n("close")}}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button
                  @click="modal_edit_email(item)"
                  class="md-just-icon md-round md-info "
                  ><md-icon>edit</md-icon></md-button
                >
                <md-button
                  @click="modal_delete_email(item)"
                  class="md-just-icon md-round md-danger md-info left-icon"
                  ><md-icon>close</md-icon></md-button
                >
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <table-page :total="modal_total" :pageSize="modal_pageSize" v-model="modal_currentPage"/>
        </div>
      </template>
    </simple-modal>
    <!-- 弹窗 Server -->
    <simple-modal ref="server" :title="$I18n('setting_server')" :right="true" :submitBtn="false">
      <template slot="body">
        <!-- 服务器 -->
        <div>
          <common-form-item 
            v-for="item in form_serverData" 
            v-model="modalData.Form[item.keys]" 
            :error="modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
      <template slot="footer-btn">
        <md-button v-if="modalData.Form.type === 12" class="left-icon md-info"  @click="modal_classicModalReset">{{$I18n("reset_devcie_state")}}</md-button>
        <!-- <md-button class="md-danger left-icon" @click="() => table_deleteServiceItem(modalData.Form)">{{$I18n("delete")}}</md-button> -->
      </template>
    </simple-modal>

    <!-- 弹窗 Email -->
    <simple-modal ref= "email_edit" :title="modalTitleEmail" :right="openModalTypeEmail!=='delete'" @submit="modal_submitEmail">
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalTypeEmail==='delete'">{{$I18n("check_delete", modalDataEmail.Form.link)}}</div>
        <!-- 修改/添加弹窗 -->
        <div v-else>
          <common-form-item 
            v-for="item in form_emailData" 
            v-model="modalDataEmail.Form[item.keys]" 
            :error="modalDataEmail.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal >
    <!-- 删除弹窗-server -->
    <simple-modal ref="delete_server" :title="$I18n('is_sure_del')" @submit="modal_submitDeleteServer">
      <template slot="body">{{$I18n("check_delete", modalDelete.net_addr)}}</template>
    </simple-modal>
    <!-- 删除弹窗-service -->
    <simple-modal ref="delete_service" :title="$I18n('is_sure_del')" @submit="modal_submitDeleteService">
      <template slot="body">{{$I18n("check_delete", modalDelete.name)}}</template>
    </simple-modal>
  </div>
</template>
<script>
import ZoneSelectModal from "@/components/Common/ZoneSelectModal";
// import { CollapseTransition } from "vue2-transitions";
import { FormClass, timestampToString1000, stringToJSON } from "@/common/tools.js";
import {countryArray, continentArray} from "@/common/continent.js";

export default {
  components: {
    ZoneSelectModal,
    // CollapseTransition,
  },
  props: ["userinfo_sys"],
  data() { 
    return {
      countryArray,
      continentArray,
      show_more:[],
      zoneSearch : "",
      modalDelete         : {}, 
      //顶部显示信息
      serverInfo: new FormClass({
        ip_num : 0,
        srv_num : 0,
        online_num : 0,
        offline_num : 0,
        noauth_num : 0,
        cancel_num : 0,
        warning_num: 0,
      }),

      openModalTypeEmail : "",
      modalTitleEmail : "",
      modalDataEmail : new FormClass({
        sys: this.userinfo_sys,
        link_type:1,
        link:{
          init: "",
          check: "required",
        },
        state:1,
      }),

      modal_currentPage : 1,
      modal_pageSize : 10,
      modal_total :0,
      modalTableData: [],
      searchForm : {Form:{
        searchType: "ip",
        searchValue: "",
        region  : "",
        zone    : "",
        state   : 0,
        type    : 0,
        // type    : [0],
      }},
      searchData : {
        net_addr: "",
        sys     : "",
        region  : "",
        zone    : "",
        state   : 0,
        type    : 0,
      },
      server_simp_type: this.$Param.serverSimpType.map(item => {
        if(item.i18n){
          return {
            ...item,
            name : this.$I18n(item.name),
          }
        }
        return {...item}
      }),
      server_type : this.$Param.serverType.map(item => {
        if(item.i18n){
          return {
            ...item,
            name : this.$I18n(item.name),
          }
        }
        return {...item}
      }),
      continent : {
        "AF" : this.$I18n("africa"),
        "EU" : this.$I18n("europe"),
        "AS" : this.$I18n("asia"),
        "OA" : this.$I18n("oceania"),
        "NA" : this.$I18n("north_america"),
        "SA" : this.$I18n("latin_america"),
        "AN" : this.$I18n("antarctica"),
      },
      // 表格相关
      icon  : "computer",
      title : this.$I18n("device_info"),
      tableInitData : [], // 表格数据

      // 分页相关
      pageSize : 10,
      currentPage : 1,
      // total : 0,

      // 弹窗表单相关
      modalData : new FormClass({ }),
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: { 
    // 类型支持多选 (暂时不删)
    // 'searchForm.Form.type':function(newValue, oldValue){
    //   // 全部不选 -> 自动选择'全选'
    //   if(newValue.length === 0){
    //     this.searchForm.Form.type = [0]
    //   }
    //   // 全部 -> 单独选择 (删除'全部'选项)
    //   if(oldValue.includes(0) && oldValue.length == 1 && newValue.length > 1){
    //     this.searchForm.Form.type = newValue.filter(i => i != 0)
    //   }
    //   // 筛选 -> 全部 (删除其他选项只保留'全部')
    //   if(!oldValue.includes(0) && newValue.includes(0)){
    //     this.searchForm.Form.type = [0]
    //   }
    // },


    'searchForm.Form.searchType':function() {
      this.searchForm.Form.searchValue = "";
    },
    modal_currentPage(){
      this.api_getEmail()
    },
    pageSize(){
      this.currentPage = 1;
      document.getElementsByClassName("main-panel")[0].scrollTop = 0;
      this.api_getPageData();
    },
    "modalDataEmail.Form.link_type":function(value){
      if(value == 2){
        this.modalDataEmail.Update({
          ...this.modalDataEmail.Form,
          link : "+86",
        })
      } else {
        this.modalDataEmail.Update({
          ...this.modalDataEmail.Form,
          link : "",
        })
      }
    },
    // 输出表格用
    // tableData(newValue){
    //   console.log(newValue.sort((a,b) => a.zone.localeCompare(b.zone)).map(i => {
    //     return `${i.zone}-${i.zone_name}	${i.net_addr}	${i.service_item.map(si => {
    //       return `${si.type_name}${si.master_name} [${si.ver}]`
    //     }).join("	")}`
    //   }).join("\n"));
    // },
  },
  methods: {
    modal_submitDeleteServer(){
      this.$api.delService({
        link_id : this.modalDelete.net_addr,
        type    : 1,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"))
          this.$refs.delete_server.close();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    modal_submitDeleteService(){
      this.$api.delService({
        link_id : this.modalDelete.app_id,
        type    : 2,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("delete_success"))
          this.$refs.delete_service.close();
          this.$refs.server.close();
          this.api_getPageData();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    table_deleteServerItem(item){
      this.$refs.delete_server.open();
      this.modalDelete = {...item}
    },
    table_deleteServiceItem(item){
      this.$refs.delete_service.open();
      let name = this.$I18n("unknow")
      let type =  this.server_type.filter(server => server.id == item.type)[0]
      if(type){
        name =  type.name
      }
      this.modalDelete = {
        ...item,
        name,
      }
    },
    changeState(newValue){
      if(this.searchData.state == newValue){
        this.searchData.state = 0
        this.searchForm.Form.state = 0
      } else {
        this.searchData.state = newValue
        this.searchForm.Form.state = newValue
      }
      this.currentPage = 1;
      this.api_getPageData()
    },
    modal_submitEmail (){
      if(this.modalDataEmail.Check()) {
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return 
      }
      if(this.openModalTypeEmail == 'add'){
        this.$api.addInfoEmail(this.modalDataEmail.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.email_edit.close();
            this.api_getEmail();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else if(this.openModalTypeEmail == 'edit'){
        this.$api.editInfoEmail(this.modalDataEmail.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.email_edit.close();
            this.api_getEmail();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      } else {
        this.$api.delInfoEmail (this.modalDataEmail.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.email_edit.close();
            this.api_getEmail();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      }
    },
    modal_add_email () {
      this.modalDataEmail.Reset()
      this.modalTitleEmail = this.$I18n("add")
      this.openModalTypeEmail = "add"
      this.$refs.email_edit.open();
    },
    modal_edit_email(item) {
      this.modalDataEmail.Update({
        link_type : item.link_type,
      })
      setTimeout(() => {
        this.modalDataEmail.Update(item)
      },0)
      this.modalTitleEmail = this.$I18n("edit")
      this.openModalTypeEmail = "edit"
      this.$refs.email_edit.open();
    },
    modal_delete_email(item) {
      this.modalDataEmail.Update(item)
      this.modalTitleEmail = this.$I18n("delete")
      this.openModalTypeEmail = "delete"
      this.$refs.email_edit.open();
    },
    api_getEmail(){
      // modalTableData
      let page = this.modal_currentPage
      this.$api.queryInfoEmail({
        page_no: this.modal_currentPage,
        page_size : this.modal_pageSize,
      })
        .then(this.$Then(res => {
          if(this.modal_currentPage == page){
            this.modalTableData = res.data.map(i => {
              return {
                ...i,
                create_time : timestampToString1000(i.gmt_create),
                update_time : timestampToString1000(i.gmt_update),
              }
            })
            this.modal_total = res.count;
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalTableData = [];
          this.modal_total = 0
        }))
    },
    // 获取页面信息
    api_getPageData(){
      // 获取角色
      let sendData = {...this.searchData}
      if(sendData.state === 5){
        sendData.state = 0;
        sendData.svr_state = 2;
      }
      this.$api.getServerList({
        ...sendData,
        "page_no": this.currentPage,
        "page_size": 9999,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data.ips;
          this.serverInfo.Update({
            ...res.data,
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.serverInfo.Reset();
        }))
    },
    form_openEmail(){
      this.modal_currentPage = 1
      this.api_getEmail()
      this.$refs.email_info.open();
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData () {
      const value = this.searchForm.Form.searchValue === "ALL" ?"" :this.searchForm.Form.searchValue
      this.searchData = {
        ...this.searchForm.Form,
        sys      : this.userinfo_sys,
        region   : this.searchForm.Form.searchType === 'region' ?value :"",
        zone     : this.searchForm.Form.searchType === 'zone'   ?value :"",
        net_addr : this.searchForm.Form.searchType === 'ip'     ?value :"",
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
    openCpuModal(item){
      this.show_more.push(item.id)
    },
    closeCpuModal(item){
      this.show_more = this.show_more.filter(id => id !== item.id)
    },
    openServerModal (item, svr) {
      this.modalTitle = this.$I18n("setting_server");
      this.$refs.server.open();
      var newValue = {
        net_addr: svr.net_addr,
        utd_addrs: [],
        ...item,
        ...item.attr,
        reg_timestamp : timestampToString1000(item.gmt_create),
        renew_timestamp : timestampToString1000(item.gmt_update),
      }
      this.modalData.Update({
        ...newValue,
        utd_addrs_str: newValue.utd_addrs.join(","),
      });
    },
    // 隐藏 弹窗
    modal_classicModalReset(){
      this.$api.resetSrver({
        srv_addr : this.modalData.Form.net_addr,
        srv_type : 12,
        cmd      : 1,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    // 提交表单
    modal_submit () {
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return 
      }
      this.$api.authServer({...this.modalData.Form})
        .then(this.$Then(() => {
          this.api_getPageData();
          this.$successMsg(this.$I18n("succ_num"));
          this.$refs.server.close();
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
  computed: {
    total(){
      return this.tableData.length
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .map(item => {
            let memory = stringToJSON(item.memory_rate)
            let disk   = stringToJSON(item.disk_rate, [])
            let memory_used = 0
            if (memory.total && memory.used){
              if (!isNaN(memory.total.replace("GB","")) && !isNaN(memory.used.replace("GB",""))){
                memory_used = memory.used.replace("GB","") / memory.total.replace("GB","") * 100
              }
            }
            return {
              ...item,
              ...item.attr,
              region_name: this.continent[item.region],
              zone_name  : this.$I18n(item.zone),
              update_time: timestampToString1000(item.gmt_update),
              create_time: timestampToString1000(item.gmt_create),
              memory : {
                ...memory,
                rate : memory_used,
              },
              disk  : disk.map(one_disk => {
                let disk_used = 0;
                if (one_disk.total && one_disk.used){
                  if (!isNaN(one_disk.total.replace("GB","")) && !isNaN(one_disk.used.replace("GB",""))){
                    disk_used = one_disk.used.replace("GB","") / one_disk.total.replace("GB","") * 100
                  }
                }
                return {
                  ...one_disk,
                  rate: disk_used,
                }
              }),
              service_item: item.details ? [...item.details]
                .map(sub_item => {
                  let master_name = ""
                  if(sub_item.master != 1) {
                    master_name =  "["+ this.$I18n("sub") +"]"
                  }
                  // 类型名称
                  let type_name   = this.$I18n("unknow")
                  let type_option = this.$Param.serverType.getOption(sub_item.type);
                  if(type_option.name){
                    if(type_option.i18n){
                      type_name = this.$I18n(type_option.name);
                    } else {
                      type_name = type_option.name;
                    }
                  }
                  return {
                    ...sub_item,
                    zone: item.zone,
                    region: item.region,
                    master_name,
                    type_name,
                  }
                })
                : [],
            }
          });
      }
    },
    tablePageData(){
      return [...this.tableData].splice((this.currentPage-1) * this.pageSize, this.pageSize).map(item => {
        let cur_load = item.attr.t_cur_load;
        let month_load = item.attr.t_month_load;
        if(!cur_load){
          cur_load = "0Mbps";
        } else if (cur_load > 1024){
          cur_load = parseFloat(cur_load/1024).toFixed(2) + "Gbps";
        } else {
          cur_load = cur_load + "Mbps"
        }
        if(!month_load){
          month_load = "0MB";
        } else if (month_load > 1024){
          month_load = parseFloat(month_load/1024).toFixed(2) + "GB";
        } else {
          month_load = month_load + "MB"
        }
        return {
          ...item,
          cur_load,
          month_load,
        }
      })
    },
    form_emailData() {
      return [
        {
          label   : this.$I18n("sys"),
          keys    : "sys",
          type    : "select",
          options : [
            {
              name: this.userinfo_sys,
              id  : this.userinfo_sys,
            },{
              name: this.$I18n("all"),
              id  : "ALL",
            }
          ],
          disabled: !this.UserInfo || this.UserInfo.role_id >= 10000,
        },{
          label   : this.$I18n("type"),
          keys    : "link_type",
          type    : "radio",
          options : [
            {
              id: 1,
              name: this.$I18n("simple_email")
            }, 
              ...(this.$router.history.current.query.lang == 'en'
              ?[]
              : [{
                id: 2,
                name: this.$I18n("simple_phone"),
              }])
          ],
          required: true,
        },{
          label   : this.$I18n(this.modalDataEmail.Form.link_type == 1 ?"simple_email" :"phone_number"),
          keys    : "link",
          type    : "input",
          required: true,
          check   : true,
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "radio",
          options : [
            {
              id: 1,
              name: this.$I18n("open")
            },{
              id: 2,
              name: this.$I18n("close")
            }
          ],
          required: true,
        },
      ]
    },
    form_serverData() {
      return [
        {
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          options : this.server_type,
          disabled: true,
        },{
        //   label   : this.$I18n("other_host_name"),
        //   keys    : "name",
        //   type    : "input",
        // },{
          label   : this.$I18n("main_server"),
          keys    : "master",
          type    : "radio",
          disabled: true,
          options : [
            {
              id  : 1,
              name: this.$I18n("main_server"),
            },{
              id  : 2,
              name: this.$I18n("sub_server"),
            },
          ],
        },{
          label   : this.$I18n("app_id"),
          keys    : "app_id",
          type    : "input",
          disabled: true,
        },{
          label   : this.$I18n("sys"),
          keys    : "sys",
          type    : "input",
          disabled: true,
        },{
          label   : this.$I18n("env"),
          keys    : "env",
          type    : "input",
          disabled: true,
        },{
          label   : this.$I18n("belong_co"),
          keys    : "region",
          type    : "input",
          check   : true,
          disabled: true,
        },{
          label   : this.$I18n("belong_areas"),
          keys    : "zone",
          type    : "input",
          check   : true,
          disabled: true,
        },{
          label   : this.$I18n("status"),
          keys    : "state",
          type    : "select",
          disabled: true,
          options : [
            {
              id  : 1,
              name: this.$I18n("inline"),
            },{
              id  : 2,
              name: this.$I18n("offline"),
            },{
              id  : 3,
              name: this.$I18n("unauth"),
            },{
              id  : 4,
              name: this.$I18n("outline"),
            },
          ],
        },{
          label   : this.$I18n("grpc_addr"),
          keys    : "grpc_addr",
          type    : "input",
          hide    : !this.modalData.Form.grpc_addr,
          disabled: true,
        },{
          label   : this.$I18n("http_addr"),
          keys    : "http_addr",
          type    : "input",
          hide    : !this.modalData.Form.http_addr,
          disabled: true,
        },{
          label   : this.$I18n("https_addr"),
          keys    : "https_addr",
          type    : "input",
          hide    : !this.modalData.Form.https_addr,
          disabled: true,
        },{
          label   : this.$I18n("tcp_addr"),
          keys    : "tcp_addr",
          type    : "input",
          hide    : !this.modalData.Form.tcp_addr,
          disabled: true,
        },{
          label   : this.$I18n("dev_load"),
          keys    : "dev_load",
          type    : "input",
          hide    : !this.modalData.Form.dev_load,
          disabled: true,
        },{
          label   : this.$I18n("utd_addrs"),
          keys    : "utd_addrs_str",
          type    : "input",
          hide    : this.modalData.Form.type != 12,
          disabled: true,
        },{
          label   : this.$I18n("max_load"),
          keys    : "max_load",
          type    : "input",
          hide    : this.modalData.Form.type != 12,
          disabled: true,
        },{
          label   : this.$I18n("lic_load"),
          keys    : "lic_num",
          type    : "input",
          hide    : !this.modalData.Form.lic_num,
          disabled: true,
        },{
          label   : this.$I18n("reg_timestamp"),
          keys    : "reg_timestamp",
          type    : "input",
          disabled: true,
        },{
          label   : this.$I18n("latest_timestamp"),
          keys    : "renew_timestamp",
          type    : "input",
          disabled: true,
        },
      ]
    },
  },
}
</script>
<style lang="css" scoped>
/*  .num-box{
    margin: 5px 0;
  }*/
  .num-info-box{
    background: rgb(230,247,255);
    color: rgb(38,155,255);
    display: inline-block;
    padding: 8px 10px;
    border-radius: 8px;
    margin: 3px 0;
  }

  .main-table .bold{
    /*font-weight: 600 !important;*/
  }
  .main-table /deep/ th div{
    /*font-weight: 600 !important;*/
  }
  .main-table /deep/ div{
    white-space: nowrap;
  }
  .main-table /deep/ .server{
    white-space: break-spaces;
  }
  .main-table .md-chip, .main-table .md-chip:hover{
    padding:  0 6px !important;
    border-radius: 5px;
  }
  .main-table .md-chip .md-ripple, .main-table .md-chip:hover .md-ripple {
    padding: 0px 0px !important;
  }
</style>
<style lang="scss" scoped>
  .info-feet{
    margin-top: 10px;
    border-top: 2px solid #f7f7f7;
    padding-top: 10px;
  }
  .info-main-box{
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    & .info-sub{
      margin-top: 5px;
      padding-left: 5px;
      padding-right: 5px;

      & .info-title{
        color: #4d545e;
        border-left: 6px solid #ccf2f6;
        padding-left: 10px;
        font-size: 16px;
        font-weight: 600;
      }
      & .info-value{
        padding: 8px 0px 0 16px;
        margin-bottom: -15px;
      }
    }
  }
  .info-sub-box{
    display: flex;
    flex-direction: column;

    border-right: 2px solid #f7f7f7;
    margin-right: 5px;

    & .info-sub{
      margin: 8px 0 5px 5px;

      & .info-title{
        color: #4d545e;
        border-left: 6px solid #ccf2f6;
        padding-left: 10px;
      }
      & .info-value{
        padding: 0 0 8px 16px;
        font-weight: 600;
        font-size: 16px;
        & p {
          margin: 8px 0;
        }
      }
    }
  }
  .info-head{
    display: flex;
    align-items: stretch;
    margin-top: 10px;
    margin-bottom: 10px;
    >div{
      padding: 0 5px;
    }

    & .info-online, & .info-zone{
      line-height: 26px;
      font-size: 23px;
      font-weight: 400;
      border-bottom: 2px solid #efefef7d;
      margin-bottom: 5px;
      padding: 0 0px 8px;
      & .right-button-box{
        flex-grow: 1;
        text-align: right;

        & .delete-button{
          border: 0;
          background: unset;
          cursor:pointer;
          color: #00bcd4;
          height: 26px;
          & .md-icon{
            color: #00bcd4;
            font-size: 10px;
          }
        }
      }
    }

    & .info-device{
      min-width: 160px;
      max-width: 220px;
      & .info-online{
        text-align: left;
        // color: rgb(84, 173, 88);
        padding-bottom: 13px;
        margin-right: 5px;
      }
      & .info-legal{
        font-size: 14px;
        text-align: left;
      }
    }
    & .info-main{
      & .info-zone{
        display: flex;
        align-items: flex-end;
        // justify-content: center;
        padding-left: 10px;
        color: rgb(90,90,90);

        & .info-reg{
          margin-left: 5px;
          font-size: 14px;
          line-height: 12px;
        }
      }
      & .info-ip-mac{
        display: flex;
        padding: 0 10px;
        & .info-ip{
          font-weight: 400;
          color: #00bcd4;
          font-size: 14px;
        }
        & .info-mac{
          flex-grow: 1;
          text-align: right;
        }
      }
    }
  }

  .info-details{
    text-align:left;
    margin-bottom: 10px;
    color: #00bcd4 ;
    font-weight: 400;
    cursor: pointer;
  }

  .no-top{
    margin-top: 0 !important;
  }
  // 标签属性
  .md-chip{ 
    cursor:pointer;
    line-height: 24px;
    height: 24px;
    margin: 2px 3px !important;

    & .md-ripple, &:hover .md-ripple{
      padding: 0px 6px !important;
    }

    &.md-info{
      background: rgb(0, 188, 212) !important;
    }
    &.md-danger{
      background: #f44336 !important;
    }
  }

  .canclick:hover, .canclick.selected {
    color : #26c6da;
    cursor: pointer;
  }

  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }

  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
</style>